/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Footer from "../components/footer";
import Header from "../components/header";
import { IsStringNullEmptyOrUndefined } from "../utils/nullCheck";

function NonAuthLayout({ page }: { page: JSX.Element }) {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [pathURL, setPathURL] = useState<string>(location.pathname);

  const isForApp: string | null = queryParams.get("isForApp");
  const [appFlag, setAppFlag] = useState<boolean>(false);

  useEffect(() => {
    if (
      isForApp &&
      !IsStringNullEmptyOrUndefined(isForApp) &&
      isForApp === "1" &&
      (pathURL === "/terms-and-conditions" || pathURL === "/privacy-policy")
    ) {
      setAppFlag(true);
    }
  }, []);

  useEffect(() => { setPathURL(location.pathname); }, [location.pathname]);

  return (
    <>
      <div className={
        (pathURL.includes("add-contact")) || (pathURL.includes("india-design"))
          || (pathURL.includes("qualified-traders")) || (pathURL === "india-design-invite")
          ? "addContactWrapper" : ""}
      >
        {!appFlag && <Header />}
        {page}
        {!appFlag && <Footer />}
      </div>
    </>
  );
}

export default NonAuthLayout;
